import React, { useContext, useEffect, useState } from "react";
import { IconDownload, IconPdf } from "@tabler/icons-react";
// import { UserServiceContext } from "../services/user/userService";
import { CommonServiceContext } from "../services/common/commonService";
import { el } from "date-fns/locale";




const DownloadSticker = ({
    docUrl,
    closeDialog
}) => {

    const { downloadStickerByTrackingNumber } = useContext(CommonServiceContext);
    const [fileDownloadPossiable, setfileDownloadPossiable] = useState(true);

    const handleDownlodSticker = async (e) => {
        e.preventDefault();

        const success = await downloadStickerByTrackingNumber(docUrl);

        console.log(success);

        if (!success) {
            setfileDownloadPossiable(false);
            return;
        }
        closeDialog?.();
    };

    return (
        <div>
            {
                fileDownloadPossiable &&
                (
                    <div className="btn btn-primary">
                        <a
                            onClick={handleDownlodSticker} target="_blank" rel="noopener noreferrer">
                            <div
                                className="flex items-space-between gap-2"
                                style={{ cursor: "pointer", color: "#fff" }}
                            >
                                <IconDownload className="w-[18px] h-[18px] " />
                                <span>გადმოწერა</span>
                            </div>
                        </a>
                    </div>
                )
            }

            {
                !fileDownloadPossiable &&
                (
                    <div className="text text-danger">ფაილის გადმოწერა ვერ შეუძლებელია</div>
                )
            }
        </div>
    );
};

export default DownloadSticker;